@import '../../../theme.scss';

verdocs-field-payment {
  font-family: $verdocs-primary-font;
  width: 24px;
  height: 24px;
  display: block;
  font-size: 11px;
  position: relative;
  scroll-margin: 20px 0;
  border: 1px solid #cfa;
  background-color: transparent;
  transform-origin: bottom left;

  &.disabled {
    opacity: 0.5;
  }

  button,
  div {
    box-sizing: border-box;
  }

  button {
    color: rgba(0, 0, 0, 0.87);
    font-weight: 500;
    transform-origin: 0 0;
    //background-color: rgba(225, 255, 255, 0.5);
    height: 100%;
    width: 100%;
    background: none;
    font-size: 11px;

    &.hide {
      display: none;
    }
  }

  input {
    float: left;
    font-family: Arial, sans-serif;
  }

  select {
    position: absolute;
    font-family: Arial, sans-serif;
    background: linear-gradient(55deg, transparent 50%, #333 50%), linear-gradient(125deg, #333 50%, transparent 50%), linear-gradient(to right, transparent, transparent);
    background-position:
      calc(100% - 7px) 4px,
      calc(100% - 3px) 4px,
      100% 0;
    background-size:
      5px 5px,
      5px 5px,
      2.5em 2.5em;
    background-repeat: no-repeat;
    appearance: none;
  }

  .frame {
    width: 100%;
    height: 100%;
    background-size: contain;
    text-align: left;

    img {
      position: absolute;
      height: auto;
      width: 100%;
    }
  }

  .settings-icon {
    position: absolute;
    top: -3px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}
